import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "tabs-container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxTabs = _resolveComponent("DxTabs")!
  const _component_GridTabCampanii = _resolveComponent("GridTabCampanii")!
  const _component_GridCampaniiDetalii = _resolveComponent("GridCampaniiDetalii")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DxTabs, {
      "data-source": _ctx.tabs,
      "selected-index": _ctx.selectedIndex,
      "onUpdate:selectedIndex": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedIndex) = $event)),
      "item-template": _ctx.tabTemplate
    }, null, 8, ["data-source", "selected-index", "item-template"]),
    (_ctx.selectedIndex === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_GridTabCampanii, { onSelectCampaign: _ctx.onCampaignSelected }, null, 8, ["onSelectCampaign"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.selectedIndex === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_GridCampaniiDetalii, {
            campaign: _ctx.selectedCampaign,
            onBack: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedIndex = 0))
          }, null, 8, ["campaign"])
        ]))
      : _createCommentVNode("", true)
  ]))
}